import * as Reducers from './device-group.reducers';

import * as MetaReducers from './device-code.metareducer';

export const DeviceGroupReducers = {
  Reducers,
  MetaReducers,
};
